//Script for controlling time slot variant visibility on the December Delivery Page

console.log('December time slot logic loaded');
var three2six = document.getElementById('template--15360722731223__main-Time Slot-2');
var three2sixLabel = document.getElementById('template--15360722731223__main-Time Slot-2').nextElementSibling;
three2six.style.display = 'none';
three2sixLabel.style.display = 'none';

var dec1 = document.getElementById('template--15360722731223__main-Date-0').addEventListener("click", Weekday);
var dec2 = document.getElementById('template--15360722731223__main-Date-1').addEventListener("click", Weekend);
var dec3 = document.getElementById('template--15360722731223__main-Date-2').addEventListener("click", Weekend);
var dec4 = document.getElementById('template--15360722731223__main-Date-3').addEventListener("click", Weekday);
var dec5 = document.getElementById('template--15360722731223__main-Date-4').addEventListener("click", Weekday);
var dec6 = document.getElementById('template--15360722731223__main-Date-5').addEventListener("click", Weekday);
var dec7 = document.getElementById('template--15360722731223__main-Date-6').addEventListener("click", Weekday);
var dec8 = document.getElementById('template--15360722731223__main-Date-7').addEventListener("click", Weekday);
var dec9 = document.getElementById('template--15360722731223__main-Date-8').addEventListener("click", Weekend);
var dec10 = document.getElementById('template--15360722731223__main-Date-9').addEventListener("click", Weekend);
var dec11 = document.getElementById('template--15360722731223__main-Date-10').addEventListener("click", Weekday);
var dec12 = document.getElementById('template--15360722731223__main-Date-11').addEventListener("click", Weekday);
var dec13 = document.getElementById('template--15360722731223__main-Date-12').addEventListener("click", Weekday);
var dec14 = document.getElementById('template--15360722731223__main-Date-13').addEventListener("click", Weekday);
var dec15 = document.getElementById('template--15360722731223__main-Date-14').addEventListener("click", Weekday);
var dec16 = document.getElementById('template--15360722731223__main-Date-15').addEventListener("click", Weekend);
var dec17 = document.getElementById('template--15360722731223__main-Date-16').addEventListener("click", Weekend);
var dec18 = document.getElementById('template--15360722731223__main-Date-17').addEventListener("click", Weekday);
var dec19 = document.getElementById('template--15360722731223__main-Date-18').addEventListener("click", Weekday);
var dec20 = document.getElementById('template--15360722731223__main-Date-19').addEventListener("click", Weekday);
var dec21 = document.getElementById('template--15360722731223__main-Date-20').addEventListener("click", Weekday);
var dec22 = document.getElementById('template--15360722731223__main-Date-21').addEventListener("click", Weekday);
var dec23 = document.getElementById('template--15360722731223__main-Date-22').addEventListener("click", Weekend);

function Weekday() {
  console.log('Weekday Triggered');
three2six.style.display = 'none';
three2sixLabel.style.display = 'none';
}

function Weekend() {
  console.log('Weekend Triggered');
three2six.style.display = 'inline-block';
three2sixLabel.style.display = 'inline-block';
}